import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom'
import { ChatBot } from '@/components/ChatBot'
import { ChatBotProvider } from '@/contexts/ChatBotContext'
import { CookieConsentProvider } from '@/contexts/CookieConsentContext'
import { ModalProvider } from '@/contexts/ModalContext'
import { CookieConsent } from '@/components/CookieConsent'
import { LanguageRouter } from '@/components/LanguageRouter'
import { AuthProvider, useAuth } from '@/contexts/AuthContext'
import { AdminDashboard } from '@/pages/admin'
import { LoginPage } from '@/pages/LoginPage'

function ChatBotVisibility() {
  const location = useLocation()
  const hide = location.pathname === '/login' || location.pathname.startsWith('/admin')
  return hide ? null : <ChatBot />
}

function ProtectedAdminDashboard() {
  const { user, loading } = useAuth()
  if (loading) return null
  return user ? <AdminDashboard /> : <Navigate to="/login" replace />
}

function AdminRoutes() {
  return (
    <Routes>
      <Route path="dashboard" element={<ProtectedAdminDashboard />} />
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  )
}

export default function App() {
  return (
    <BrowserRouter>
      <ModalProvider>
        <AuthProvider>
          <CookieConsentProvider>
            <ChatBotProvider>
              <Routes>
                <Route path="/login" element={<LoginPage />} />
                <Route path="/admin/*" element={<AdminRoutes />} />
                <Route path="/*" element={<LanguageRouter />} />
              </Routes>
              <ChatBotVisibility />
              <CookieConsent />
            </ChatBotProvider>
          </CookieConsentProvider>
        </AuthProvider>
      </ModalProvider>
    </BrowserRouter>
  )
}
